module.exports = __webpack_public_path__ + "img/c-dagger.a5517355.svg";